/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.modals.checkout.controllers', [
  'acme.common.directive.modal'
])

.controller('ModalsCheckoutController', ['$scope', function($scope) {

    $scope.modalsCheckout = {

      title: "One moment ...",
      model: "Please wait while the order is being processed.",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.modalsCheckout.init();

}]);